export default {
    name: 'sites',
    state: {
        tempat: [
            { value: "Jl. Sriwijaya no 36 Surabaya 60265, Indonesia", label: "Jl. Sriwijaya no 36 Surabaya 60265, Indonesia", nama: "Sites Sriwijaya" },
            { value: "Jl. Dinoyo no 109 Surabaya, Indonesia", label: "Jl. Dinoyo no 109 Surabaya, Indonesia", nama: "Sites Dinoyo" },
            { value: "Jl. Cilangkap Raya No.28 Jakarta 13840, Indonesia", label: "Jl. Cilangkap Raya No.28 Jakarta 13840, Indonesia", nama: "Sites Jakarta" },
        ],
    },
    getters: {
        getSites: state => {
            return state.tempat
        },

    },
}